import React from "react";
import { Link } from "react-router-dom";

export default function HomePage() {
  return (
    <div className="w-full h-full py-16 px-4 flex flex-col items-center justify-center text-center">
      <img
        src="/images/apel_logo.jpg"
        alt="Logo Stanislas"
        className="w-24 h-24 mb-6"
      />

      <h1 className="text-4xl font-bold mb-2">Apel Stanislas</h1>
      <Link
        to="/books"
        className="mb-6 inline-block text-blue-600 font-medium underline py-2 px-4 rounded-md transition "
      >
        Bourse aux livres
      </Link>

      <p className="text-sm italic text-gray-500 max-w-3xl">
        L’Apel Stanislas, association des parents d’élèves de Stanislas, se
        réserve le droit de supprimer à tout moment les annonces de ce site,
        sans préavis. Les utilisateurs reconnaissent qu’ils ne pourront en
        aucune façon porter réclamation de quelque nature que ce soit en cas
        d’interruption totale ou partielle des services ou rubriques proposés
        sur le site. L’Apel Stanislas n’assume aucune responsabilité quant aux
        informations que contient le présent site dans leur qualité autant que
        dans leur exactitude.
      </p>
    </div>
  );
}
